import BaseListener from "./baseListener";
import { TrackEvent } from "./baseListener";
class ButtonClickListener extends BaseListener {
  private observer: any = null;

  constructor() {
    super();
    this.createObserver();
  }

  private createObserver() {
    this.observer = new MutationObserver((mutations: any) => {
      mutations.forEach((mutation: any) => {
        // 只处理当前容器内的变化
        if (!mutation.target.isConnected) return;
        (mutation.target as HTMLElement).querySelectorAll('a,button,.winitd-dropdown-menu-title-content')
          .forEach((el) => {
            const htmlEl = el as HTMLElement;
            if (!htmlEl.dataset?.trackerBound) {
              htmlEl.dataset.trackerBound = 'true';
              htmlEl.addEventListener('click', () => this.handleClick(htmlEl));
            }
          });
      });
    });
  }

  private handleClick = (el: HTMLElement) => {
    let fieldKey = el.getAttribute?.('id') || '',
      fieldLabel = el.getAttribute?.('aria-label') || '',
      buttonContent = el.innerText?.trim() || el.getAttribute?.('title') || '';
    // 文件上传控件中的删除按钮
    const formItem = el.closest('.winitd-form-item');
    if (formItem && !fieldKey) {
      const labelElement = formItem.querySelector<HTMLElement>('.winitd-form-item-label label');
      fieldKey = labelElement?.getAttribute('for') || '';
    }

    if (fieldKey || fieldLabel || buttonContent) {
      this.config.onEmit({
        nodeType: 'click',
        nodeName: el.nodeName,
        nodeDesc: buttonContent,
        fieldKey,
        fieldLabel,
        timestamp: Date.now(),
      },el);
    }
  };

  start(onEmit: (event: TrackEvent, el?: HTMLElement) => void, container: HTMLElement) {
    this.config = {
      onEmit: onEmit,
      container: container,
    };
    this.observer.observe(this.config.container, {
      childList: true,
      subtree: true
    });
  };


  stop() {
    this.config.container.querySelectorAll('[data-tracker-bound="true"]').forEach((el:any) => {
      el.removeEventListener('click', () => this.handleClick(el));
    });
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

export default ButtonClickListener;
